document.addEventListener("DOMContentLoaded", () => {
if (!customElements.get('card-carsouel')) {
    class CartSwiper extends HTMLElement {
        setupSwiper;
        constructor() {
            super();

        }
        connectedCallback() {
            this.style.display = "block"
            this.setupSwiper = new Swiper(this.querySelector('.setup-components-content'), {
                slidesPerView: 4,
                spaceBetween: 20,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                breakpoints: {
                    769: {
                        slidesPerView: 4,
                  
                    },
                    501: {
                        slidesPerView: 2,
                     
                    },
                    300: {
                        slidesPerView: 1.15,
                   
                    },
                }
            });
            this.initEvent(this.setupSwiper);

        }


    }
    customElements.define('card-carsouel', CartSwiper);
}
});




